<template>
<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        @click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <AlertList />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import AlertList from '@/components/settings/stock-registers/alerts/AlertList'

export default {
  name: 'Alert',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    AlertList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addalert' })
    }
  }
}
</script>